/**
 * @deprecated please use values from ThemeProvider
 */
const colors = {
  /**
   * @deprecated Use `theme.core.color.neutral[900]` instead.
   */
  white: '#FFFFFF',
  /**
   * @deprecated Use `theme.core.color.neutral[800]` instead.
   */
  pearl: '#F3F3F6',
  /**
   * @deprecated Use `theme.core.color.neutral[750]` instead.
   */
  sand: '#E3E3E7',
  /**
   * @deprecated Use `theme.core.color.dollar[800]` instead.
   */
  mint: '#DEEAE6',

  /**
   * @deprecated Use `theme.core.color.neutral[600]` instead.
   */
  concrete: '#CDCDD8',
  /**
   * @deprecated Use `theme.core.color.neutral[700]` instead.
   */
  smoke: '#D5D4D9',

  /**
   * @deprecated Use `theme.core.color.ocean[700]` or `theme.core.color.sky[700]`  instead
   */
  sky: '#DBE1FF',
  /**
   * @deprecated Use `theme.core.color.sky[600]` or `theme.core.color.ocean[600]` instead.
   */
  cloud: '#C7CEEE',
  /**
   * @deprecated Use `theme.core.color.ink[700]` instead
   */
  lilac: '#D6D0FC',
  /**
   * @deprecated Use `theme.core.color.violet[700]` or `theme.core.color.orchid[700]` instead.
   */
  lavender: '#EFDDF8',
  /**
   * @deprecated Use `theme.core.color.neutral[550]` instead.
   */
  mouse: '#9D9DB4',
  /**
   * @deprecated Use `theme.core.color.neutral[500]` instead.
   */
  pigeon: '#7A7A98',
  /**
   * @deprecated Use `theme.core.color.dollar[600]` instead.
   */
  grass: '#6CB8A0',
  /**
   * @deprecated Use `theme.core.color.mint[500]` or `theme.core.color.success[500]`  instead
   */
  success: '#36CD97',
  /**
   * @deprecated Use `theme.core.color.dollar[400]` instead.
   */
  forest: '#1E6C55',
  /**
   * @deprecated Use `theme.core.color.dollar[500]` instead.
   */
  dollar: '#2E876C',
  /**
   * @deprecated Use `theme.core.color.violet[600]` or `theme.core.color.orchid[600]` instead.
   */
  lotus: '#C583E4',
  /**
   * @deprecated Use `theme.core.color.violet[500]` or `theme.core.color.orchid[500]` instead.
   */
  orchid: '#9E46C8',
  /**
   * @deprecated Use `theme.core.color.violet[700]` or `theme.core.color.orchid[700]` instead.
   */
  lavander: '#efddf8',
  /**
   * @deprecated Use `theme.core.color.ink[500]` instead
   */
  ink: '#6755D1',
  /**
   * @deprecated Use `theme.core.color.ink[600]` instead
   */
  clematis: '#A597FF',
  /**
   * @deprecated Use `theme.core.color.ink[400]` instead
   */
  indigo: '#4F3FAA',
  /**
   * @deprecated Use `theme.core.color.ocean[500]` or `theme.core.color.sky[500]` instead.
   */
  ocean: '#8497FA',
  /**
   * @deprecated Use `theme.core.color.sky[400]` or `theme.core.color.ocean[400]` instead.
   */
  twilight: '#677BE1',
  /**
   * @deprecated Use `theme.core.color.wine[500]` instead.
   */
  error: '#F6694A',
  /**
   * @deprecated Use `theme.core.color.ginger[500]` instead.
   */
  warning: '#ff9d56',
  /**
   * @deprecated Use `theme.core.color.neutral[300]` instead.
   */
  navy: '#32395A',
  /**
   * @deprecated Use `theme.core.color.neutral[200]` instead.
   */
  night: '#1E233A',

  // Not sure what to map these colors to
  quartz: '#DEDEE7',
  melon: '#FFE1DA',
  color1: '#CEE2DB',
  color2: '#B9B9CD',
  color3: '#9797AC',
  color4: '#E6E4F1',
  color5: '#E5CFEF',
  color6: '#d06f59',
} as const;

export default colors;
